"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BlockSubtitle = _interopRequireDefault(require("./BlockSubtitle.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BlockSubtitle = function BlockSubtitle(_ref) {
  var children = _ref.children,
    id = _ref.id,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_BlockSubtitle["default"], {
    id: id,
    className: className
  }, children);
};
BlockSubtitle.defaultProps = {
  id: 'blockSubtitle',
  className: 'block-subtitle'
};
BlockSubtitle.propTypes = {
  children: _propTypes["default"].node.isRequired,
  id: _propTypes["default"].string,
  /**
   * The css classes for the block subtitle
   */
  className: _propTypes["default"].string
};
BlockSubtitle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BlockSubtitle",
  "props": {
    "id": {
      "defaultValue": {
        "value": "'blockSubtitle'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'block-subtitle'",
        "computed": false
      },
      "description": "The css classes for the block subtitle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(BlockSubtitle);
exports["default"] = _default;